export function state(initialState) {
  return {};
}
